export default function formatEnum(str = "") {
  if (!str) return;
  const wordsArr = str.split("_");
  let newArr = wordsArr.map(
    (word) => word.charAt(0) + word.slice(1).toLowerCase()
  );
  const formattedText = newArr.join(" ");
  return formattedText;
}
